import React, { useState } from "react";
import * as S from "./styles";
import { MOVIMIENTOS_POR_PAGINA } from "../../constants";

export const Paginator = ({ pagination, onChange }) => {
  // Solo dejamos este estado si queremos que el selector sea local, 
  // aunque lo ideal sería que también viniera del padre.
  const [recordsByPage, setRecordsByPage] = useState(MOVIMIENTOS_POR_PAGINA);

  const handlePageChange = (newIndex) => {
    onChange({
      pageIndex: newIndex,
      pageSize: recordsByPage,
    });
  };

  const handleRecordsChange = (e) => {
    const newSize = Number(e.target.value);
    setRecordsByPage(newSize);
    onChange({
      pageIndex: 1, // Resetear a página 1 si cambia el tamaño es buena práctica
      pageSize: newSize,
    });
  };

  return (
    <S.Buttons>
      <button
        id="backPage"
        disabled={pagination.pageIndex <= 1}
        onClick={() => handlePageChange(pagination.pageIndex - 1)}
      >
        Anterior
      </button>
      
      <b>Página {pagination.pageIndex} de {pagination.totalPages ?? 1}</b>
      
      <button
        id="nextPage"
        disabled={pagination.pageIndex >= pagination.totalPages}
        onClick={() => handlePageChange(pagination.pageIndex + 1)}
      >
        Siguiente
      </button>

      <label htmlFor="recordsByPage">Registros por página</label>
      <S.RecordsByPage
        id="recordsByPage"
        value={recordsByPage}
        onChange={handleRecordsChange}
      >
        <option value={20}>20</option>
        <option value={50}>50</option>
        <option value={100}>100</option>
      </S.RecordsByPage>
    </S.Buttons>
  );
};
